import { Instance } from 'mobx-state-tree';
import { ActivePlanningActionsDtoModelBase } from './ActivePlanningActionsDtoModel.base';

/* The TypeScript type of an instance of ActivePlanningActionsDtoModel */
export interface ActivePlanningActionsDtoModelType extends Instance<typeof ActivePlanningActionsDtoModel.Type> {}

/* A graphql query fragment builders for ActivePlanningActionsDtoModel */
export { selectFromActivePlanningActionsDto, activePlanningActionsDtoModelPrimitives, ActivePlanningActionsDtoModelSelector } from './ActivePlanningActionsDtoModel.base';

/**
 * ActivePlanningActionsDtoModel
 */
export const ActivePlanningActionsDtoModel = ActivePlanningActionsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
